import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate, useLocation } from "react-router-dom";
import './modal.css';

export default function AutoLogout() {
  const timeout = 1000 * 60 * 20
  const promptBeforeIdle = 1000 * 60 * 10
  const [open, setOpen] = useState(false)
  const [remaining, setRemaining] = useState(0)
  const [interval, setinterval] = useState({ value: 3 });
  const originalTitle = "UNA Test";
  const blinkTitle = "⚠️ Action Required ⚠️";
  let isBlinking = false;
  const navigate = useNavigate()
  const location = useLocation();

  function startBlinking() {
    setinterval({
      value: setInterval(() => {
        document.title = isBlinking ? originalTitle : blinkTitle;
        isBlinking = !isBlinking;
      }, 1000)
    })
  }

  function stopBlinking() {
    clearInterval(interval?.value);
    document.title = originalTitle;
  }
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  const onPrompt = () => {
    if (location.pathname === "/") {
      activate()
      return
    }
    setOpen(true)
    setRemaining(0)
    startBlinking();
  }

  const onIdle = () => {
    setOpen(false)
    setRemaining(0)
    stopBlinking()
    handleLogout(true)
  }

  const onActive = () => {
    setOpen(false)
    setRemaining(0)
  }

  const { getRemainingTime, isPrompted, activate } = useIdleTimer({
    timeout,
    promptBeforeIdle,
    onPrompt,
    onIdle,
    onActive
  })

  const handleStillHere = () => {
    setOpen(false)
    activate()
    stopBlinking()
  }
  const handleLogout = (logoutStatus = false) => {
    setOpen(false)
    activate()
    stopBlinking()
    document.title = originalTitle;
    sessionStorage.clear();
    sessionStorage.setItem("logoutStatus",JSON.stringify(logoutStatus))
    navigate("/");
  }

  useEffect(() => {
    const interval = setInterval(() => {
      if (isPrompted()) {
        setRemaining(Math.ceil(getRemainingTime() / 1000))
      }
    }, 1000)
    return () => {
      clearInterval(interval)
    }
  }, [getRemainingTime, isPrompted])

  return (<>

    {open ? (
      <div id="popup-modal">
        <div className="modal-container">
          <div className="modal-content">
            <button
              type="button"
              className="close-button"
              data-modal-hide="popup-modal"
            >
            </button>
            <div className="p-6 text-center">
              <h4>Are you still there?</h4>
              <p>
                If not, we’ll close the session in:{" "}
                <span className="bold-text">{formatTime(remaining)}</span>
              </p>
              <button
                onClick={() => handleLogout(false)}
                data-modal-hide="popup-modal"
                className="logout-button"
              >
                Logout
              </button>
              <button
                onClick={handleStillHere}
                data-modal-hide="popup-modal"
                className="still-here-button"
              >
                I am still here
              </button>
            </div>
          </div>
        </div>
      </div>
    ) : null}

  </>
  )
}